var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreasingbars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.014,
    height: 20.015,
    viewBox: "0 0 20.014 20.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_186985",
    "data-name": "Group 186985",
    transform: "translate(20716 1693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75316",
    "data-name": "Path 75316",
    d: "M19.18,19.675h-.834V8.834A.834.834,0,0,0,17.513,8H14.177a.834.834,0,0,0-.834.834V19.675h-.834V12.17a.834.834,0,0,0-.834-.834H8.339a.834.834,0,0,0-.834.834v7.505H6.671v-5a.834.834,0,0,0-.834-.834H2.5a.834.834,0,0,0-.834.834v5H.834a.834.834,0,1,0,0,1.668H19.18a.834.834,0,1,0,0-1.668Z",
    transform: "translate(-20716 -1694.328)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75317",
    "data-name": "Path 75317",
    d: "M3.834,9.173c5.011,0,9.456-3.839,11.675-6.143V4.17a.834.834,0,1,0,1.668,0V.834A.868.868,0,0,0,16.343,0H13.007a.834.834,0,0,0,0,1.668H14.5C12.524,3.746,8.341,7.505,3.834,7.505a.834.834,0,0,0,0,1.668Z",
    transform: "translate(-20716.498 -1693)",
    fill: "#7d96ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreasingbars);
export default __webpack_public_path__ + "static/media/increasingbars.d7b9e80d0d41005a1a31450717996ac7.svg";
export { ForwardRef as ReactComponent };